import ValueChart from './ValueChart';

export default ValueChart;
